import { render, staticRenderFns } from "./AnalyticsRating.vue?vue&type=template&id=2bd43ca8&scoped=true"
import script from "./AnalyticsRating.vue?vue&type=script&lang=js"
export * from "./AnalyticsRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd43ca8",
  null
  
)

export default component.exports